import {
  ChangeDetectorRef,
  Component, EventEmitter,
  forwardRef,
  Input, OnChanges, Output, SimpleChanges,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import {NgClass, NgIf} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'white-label-toggle',
  templateUrl: './toggle.component.html',
  standalone: true,
  imports: [
    NgClass,
    TranslateModule,
    NgIf
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true
    }
  ]
})
export class ToggleComponent implements ControlValueAccessor, OnChanges {
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() showStatusOnLabel: boolean = false;

  @Output() onChange = new EventEmitter<any>();

  value: boolean = false;

  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};

  constructor(private cdr: ChangeDetectorRef) {}

  // Toggle the value and emit changes
  toggleValue() {
    if (this.disabled) return;
    this.value = !this.value;
    this.onChange.emit(this.value)
    this.onChangeCallback(this.value);
  }

  writeValue(value: any): void {
    this.value = value || false;
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cdr.markForCheck();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.cdr.detectChanges();
  }
}
